const formatAdventurerName = (str = "") => {
  const weirdApostrophe = /[\u2018-\u2019]/g;
  str = str.trim().replace(weirdApostrophe, "'").replace(/\s\s+/g, " ");
  str = str.charAt(0).toUpperCase() + str.substr(1);
  return str;
};

export default formatAdventurerName;
